import React from "react";
import AdminFeatureTour, {
  markTourSeen,
  shouldAutoStartTour,
} from "../../components/AdminFeatureTour";

export const RULES_TOUR_STORAGE_KEY = "vr_admin_rules_tour_seen_v1";

export const RULES_TOUR_STEPS = [
  {
    id: "welcome",
    target: "tour-theme-settings",
    title: "Welcome to Theme Rules",
    body: "This page is where you set game modes, scoring, colors, and begin-screen backgrounds for your theme. Let’s walk through the main sections.",
  },
  {
    id: "modes",
    target: "tour-game-modes",
    title: "Choose game modes",
    body: "Turn Endless Runner and/or Quiz Runner on or off. When Endless is on, choose Easy / Medium / Hard and optionally enable lifelines. At least one mode should stay enabled.",
  },
  {
    id: "scoring",
    target: "tour-scoring",
    title: "Set scoring rules",
    body: "Configure scoring for the modes you enabled. Quiz fields hide when Quiz Runner is off.",
  },
  {
    id: "branding",
    target: "tour-branding",
    title: "Brand your UI",
    body: "Pick text and button colors (including the gradient) so the game matches your brand.",
  },
  {
    id: "backgrounds",
    target: "tour-begin-bg",
    title: "Begin screen backgrounds",
    body: "Upload desktop (1920×1080) and mobile (414×896) backgrounds shown on the begin screen. Exact size is required.",
  },
  {
    id: "save",
    target: "tour-actions",
    title: "Save, then continue",
    body: "Click Save to store these settings. Then Continue to Categories to add quiz questions and game images (cars, road, obstacles).",
  },
];

export default function RulesFeatureTour({ open, onClose }) {
  return <AdminFeatureTour open={open} onClose={onClose} steps={RULES_TOUR_STEPS} />;
}

export function markRulesTourSeen() {
  markTourSeen(RULES_TOUR_STORAGE_KEY);
}

export function shouldAutoStartRulesTour() {
  return shouldAutoStartTour(RULES_TOUR_STORAGE_KEY);
}
